import Frames from './frames';

export default Frames;